import api from 'api/axiosInstance';
import { type BackendActivationStepIdType } from 'components/pages/Banks/BankingSignUp/ActivationFlow/constants/stepIds';

export interface ActivationStatusResponse {
  activationFurthestStepReached: BackendActivationStepIdType | null;
}

export interface UpdateActivationResponse {
  activationFurthestStepReached: BackendActivationStepIdType;
}

/**
 * Fetch the current activation status for the user
 * @returns Promise with activation status response
 */
export const getActivationStatus = (): Promise<ActivationStatusResponse> => {
  return api.get('/v2/accountable-banking/activation');
};

/**
 * Update the furthest activation step reached by the user
 * Only updates if it represents forward progress (equal to or later than current step)
 * Backend silently ignores updates to earlier steps
 * @param step - The activation step to update to
 * @returns Promise with updated activation response
 */
export const updateActivationStatus = (
  step: BackendActivationStepIdType,
): Promise<UpdateActivationResponse> => {
  return api.patch('/v2/accountable-banking/activation', {
    activationFurthestStepReached: step,
  });
};
